/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { InstructionDto } from './InstructionDto';
import {
    instanceOfInstructionDto,
    InstructionDtoFromJSON,
    InstructionDtoFromJSONTyped,
    InstructionDtoToJSON,
} from './InstructionDto';

/**
 * @type TaskItemAreaDtoInstruction
 * 
 * @export
 */
export type TaskItemAreaDtoInstruction = InstructionDto;


export function TaskItemAreaDtoInstructionFromJSON(json: any): TaskItemAreaDtoInstruction {
    return TaskItemAreaDtoInstructionFromJSONTyped(json, false);
}

export function TaskItemAreaDtoInstructionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemAreaDtoInstruction {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...InstructionDtoFromJSONTyped(json, true) };
    return  InstructionDtoFromJSONTyped(json, true);
}

export function TaskItemAreaDtoInstructionToJSON(value?: TaskItemAreaDtoInstruction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfInstructionDto(value)) {
        return InstructionDtoToJSON(value as InstructionDto);
    }

    return {};
}

/**
 * Check if a given object implements the TaskItemAreaDtoInstruction interface.
 */
export function instanceOfTaskItemAreaDtoInstruction(value: any): value is TaskItemAreaDtoInstruction {
    if (instanceOfInstructionDto(value)) return true;
    return false;
}

